import { CKLayoutGridAuto } from 'clearkit';

import { PageLayout } from '~/components/PageLayout';

import { OverviewCard } from './OverviewCard';

export const UsageOverviewEnrichment = () => {
  return (
    <PageLayout.Content>
      <CKLayoutGridAuto minWidth="32rem">
        <OverviewCard />
      </CKLayoutGridAuto>
    </PageLayout.Content>
  );
};
